import { render, staticRenderFns } from "./ModalActivationPage.vue?vue&type=template&id=cb028d12&scoped=true"
import script from "./ModalActivationPage.vue?vue&type=script&lang=js"
export * from "./ModalActivationPage.vue?vue&type=script&lang=js"
import style0 from "./ModalActivationPage.vue?vue&type=style&index=0&id=cb028d12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb028d12",
  null
  
)

export default component.exports